import { Buffer } from "buffer";

/**
 * Adapter para descompressão de dados usando brotli-compress
 * Usa a variante JS pura que é menor e síncrona
 */
export class CompressAdapter {
    /**
     * Descomprime dados usando brotli-compress para frontend
     * @param {Object} apiResponse - Objeto contendo response e compression
     * @param {string} apiResponse.response - Dados comprimidos em base64
     * @param {string} apiResponse.compression - Tipo de compressão usado
     * @returns {Promise<any>} Dados descomprimidos
     */
    static async decompres(apiResponse) {
        const { response, compression } = apiResponse;
        try {
            // Converte base64 para Uint8Array
            const brotliBuffer = Buffer.from(response, "base64");
            const brotliUint8Array = new Uint8Array(brotliBuffer);
            // Usa a variante JS pura (síncrona e menor)
            const { decompress } = await import("brotli-compress/js");
            const decompressed = decompress(brotliUint8Array);
            // Converte Uint8Array de volta para string e faz parse do JSON
            const decompressedString = Buffer.from(decompressed).toString();
            return JSON.parse(decompressedString);
        } catch (error) {
            throw new Error(
                `Falha na descompressão com brotli-compress (${compression}): ${
                    error instanceof Error ? error.message : String(error)
                }`
            );
        }
    }
}
